import React from 'react';
import { LogOut, Info, User, Share2 } from 'lucide-react';

interface HeaderProps {
  storeName: string;
  onLogout?: () => void;
  onShare?: () => void;
  onStoreInfoClick?: () => void;
  onMyInfoClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({ storeName, onLogout, onShare, onStoreInfoClick, onMyInfoClick }) => {
  return (
    <nav className="flex z-40 w-full min-h-[64px] py-2 items-center justify-center sticky top-0 border-b bg-white/70 backdrop-blur-md">
      <header className="flex px-4 sm:px-6 w-full items-center justify-between max-w-4xl">
        <div className="flex flex-col truncate pr-2">
          <span className="text-[11px] font-bold text-emerald-600 mb-0.5">장봐드림 서비스</span>
          <h1 className="font-bold text-lg text-gray-900 truncate">{storeName}</h1>
        </div>
        <div className="flex items-center gap-1.5 shrink-0">
          {onStoreInfoClick && (
            <button
              onClick={onStoreInfoClick}
              className="h-8 px-2 sm:px-3 rounded-lg bg-white text-gray-600 text-[12px] sm:text-[13px] font-bold flex items-center gap-1.5 border border-gray-100 shadow-sm active:scale-95 transition-all"
            >
              {/* <Info size={14} />  */}
              매장 정보
            </button>
          )}
          {onMyInfoClick && (
            <button
              onClick={onMyInfoClick}
              className="h-8 px-2 sm:px-3 rounded-lg bg-white text-gray-600 text-[12px] sm:text-[13px] font-bold flex items-center gap-1.5 border border-gray-100 shadow-sm active:scale-95 transition-all"
            >
              {/* <User size={14} />  */}
              My 정보
            </button>
          )}
          {onShare && (
            <button
              onClick={onShare}
              className="p-1.5 hover:bg-gray-100 rounded-full transition-colors text-gray-500 ml-1"
              title="카카오톡으로 공유"
              aria-label="카카오톡으로 매장 공유"
            >
              <Share2 size={18} />
            </button>
          )}
          {onLogout && (
            <button
              onClick={onLogout}
              className="p-1.5 hover:bg-gray-100 rounded-full transition-colors text-gray-500 ml-1"
              title="로그아웃"
            >
              <LogOut size={18} />
            </button>
          )}
        </div>
      </header>
    </nav>
  );
};

export default Header;
